// @flow
export const noop: mixed => mixed = () => {}



// WEBPACK FOOTER //
// ./src/common/functions.js